import Chat from "../../../compoenents/Chat";
import { Outlet, Link, router, useParams, useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef, useMemo } from "react";

import Cookies from "js-cookie";
import LoginCheck from "../../../LoginCheck/page";
import { API, ApiAdmin, MAPS_API_KEY } from "../../../Values";

import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import axios from "axios";

const mapContainerStyle = {
  width: "100%",
  height: "100%",
};

const center = {
  lat: 30.033, // الموقع الافتراضي
  lng: 31.233,
};
export default function CustomerShoppingTo(Search) {
  //---------CHECK LOGIN ------------------------------
  LoginCheck();
  var userinfo = [];
  var Username = "";
  var UserID = "";
  if (Cookies.get("userinfo")) {
    userinfo = JSON.parse(Cookies.get("userinfo"));
    Username = userinfo[0].Name;
    UserID = userinfo[0].ID;
  }



  const [deliveryLocation, setDeliveryLocation] = useState(center);
  const [deliveryName, setDeliveryName] = useState("");
  const [isLoaded, setIsLoaded] = useState(false); // حالة تحميل الخريطة
  const [pickupLocation, setPickupLocation] = useState(null); // نقطة الاستلام
  const [distance, setDistance] = useState("0"); // المسافة بين نقطتي الاستلام والتسليم
  const [currentLocation, setCurrentLocation] = useState(null); // الموقع الحالي للمستخدم
  const [map, setMap] = useState(null);
  const searchInputRef = useRef();
  const autocompleteRef = useRef();
  const navigate = useNavigate();
  const libraries = useMemo(() => ["places", "geometry"], []);
  const [isLoading, setIsLoading] = useState(true);
  const [Inputs, setInputs] = useState([]);
  const [Saveplase, setSaveplase] = useState(false);
  const [AdressTitle, setAdressTitle] = useState("");

  useEffect(() => {
    const savedPickupLocation = JSON.parse(
      localStorage.getItem("pickupLocation")
    );
    if (savedPickupLocation) {
      setPickupLocation(savedPickupLocation.location);
    }
  }, [pickupLocation]);


  const [MAPS_API_KEY_, SET_MAPS_API_KEY] = useState(MAPS_API_KEY);
  useEffect(() => {
    GetApiKey();
  }, []);
  async function GetApiKey() {
    try {
      const type = "Google Maps";
      const post = {
        type: type,
        Action: "GetApiType",
      };
      const response = await fetch(ApiAdmin + "/Api_Setting.php", {
        method: "POST",
        body: JSON.stringify(post),
      });
      const data = await response.json();
      console.log("============  get api ===============");
      // console.log(data[0].token);
      SET_MAPS_API_KEY(data[0].token);
    } catch (error) {
      return error;
    }
  }
  //--------------------------------------

  useEffect(() => {
    GetMyLocation();
  }, []);

  function GetMyLocation() {
    const savedCurentLocation = JSON.parse(
      localStorage.getItem("CurentLocation")
    );
    if (savedCurentLocation) {
      // setDeliveryLocation(savedCurentLocation.location);
      // setDeliveryName(savedCurentLocation.name);
      getPlaceName(savedCurentLocation.location.lat, savedCurentLocation.location.lng);

      // setIsLoading(false);

    }
    console.log("CurentLocation");
    console.log(savedCurentLocation);
  }



  useEffect(() => {
    if (window.google && window.google.maps) {
      const input = searchInputRef.current;
      const autocomplete = new window.google.maps.places.Autocomplete(input);
      autocompleteRef.current = autocomplete;
      // عند تحديد مكان من الـ  Autocomplete
      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        if (place.geometry) {
          const location = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
          };
          setDeliveryLocation(location);
          getPlaceName(location.lat, location.lng);
          console.log(location);
          console.log(pickupLocation);
          // حساب المسافة بين نقطتي الاستلام والتسليم
          if (pickupLocation) {
            calculateDistance(pickupLocation, location);
          }
          // تحريك الخريطة إلى الموقع المحدد
          if (map) {
            map.panTo(location); // تحريك الخريطة إلى المكان المحدد
            map.setZoom(14); // تحديد مستوى التكبير عند النقطة
          }
        }
      });
    }
  }, [map]);

  const handleMapClick = async (event) => {
    const latLng = event.latLng;
    const location = {
      lat: latLng.lat(),
      lng: latLng.lng(),
    };
    setDeliveryLocation(location);
    getPlaceName(location.lat, location.lng);
    console.log(pickupLocation);
    // حساب المسافة بين نقطتي الاستلام والتسليم
    if (pickupLocation) {
      calculateDistance(pickupLocation, location);
    }
    // تحريك الخريطة إلى الموقع المحدد
    if (map) {
      map.panTo(location); // تحريك الخريطة إلى المكان المحدد
      map.setZoom(14); // تحديد مستوى التكبير عند النقطة
    }
  };


  const getPlaceName = async (latitude, longitude) => {
    try {
      const location = {
        lat: latitude,
        lng: longitude,
      };
      const response = await axios.get(`https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json&accept-language=ar`);
      setDeliveryLocation(location);
      setDeliveryName(response.data.display_name);
      setIsLoading(false);
      console.log(location);
      console.log(response.data.display_name);

      if (pickupLocation) {
        calculateDistance(pickupLocation, location);
      }

    } catch (error) {
      console.error('خطأ في جلب اسم الموقع:', error);
    }
  };

  const getPlaceName0 = (lat, lng) => {
    const location = {
      lat: lat,
      lng: lng,
    };
    const geocoder = new window.google.maps.Geocoder();
    const latLng = new window.google.maps.LatLng(lat, lng);
    geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === "OK" && results[0]) {
        setDeliveryName(results[0].formatted_address);
        // setDeliveryLocation(location);
        // localStorage.setItem(
        //   "deliveryLocation",
        //   JSON.stringify({ location, name: results[0].formatted_address })
        // );
      }
    });
  };

  // دالة حساب المسافة بين نقطتين
  const calculateDistance = (pickup, delivery) => {
    const R = 6371e3; // نصف قطر الأرض بالأمتار
    const φ1 = (pickup.lat * Math.PI) / 180; // تحويل درجة العرض الأولى إلى راديان
    const φ2 = (delivery.lat * Math.PI) / 180; // تحويل درجة العرض الثانية إلى راديان
    const Δφ = ((delivery.lat - pickup.lat) * Math.PI) / 180; // فرق العرض بالراديان
    const Δλ = ((delivery.lng - pickup.lng) * Math.PI) / 180; // فرق الطول بالراديان

    const a =
      Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const distanceInMeters = R * c; // المسافة بالأمتار
    const distanceInKilometers = distanceInMeters / 1000; // المسافة بالكيلومترات

    // تحديد الوحدات وعرض النتيجة
    let result;
    if (distanceInKilometers >= 1) {
      result = `${distanceInKilometers.toFixed(2)} كم`; // إذا كانت المسافة بالكيلومترات
    } else {
      result = `${distanceInMeters.toFixed(0)} م`; // إذا كانت المسافة بالأمتار
    }

    console.log("Distance: " + result);
    setDistance(result); // تخزين المسافة
    // حفظ اdistance__لبيانات في localStorage
    localStorage.setItem("distance", JSON.stringify({ distance: result }));
    return result; // النتيجة مع الوحدات
  };
  //=========================================================================
  //=========================================================================
  const calculateDistance0 = (pickup, delivery) => {
    const service = new window.google.maps.DistanceMatrixService();
    // const pickup = convertArabicNumbersToEnglish(pickup_);
    // const delivery = convertArabicNumbersToEnglish(delivery_);
    service.getDistanceMatrix(
      {
        origins: [pickup],
        destinations: [delivery],
        travelMode: window.google.maps.TravelMode.DRIVING,
        unitSystem: window.google.maps.UnitSystem.METRIC,
      },
      (response, status) => {
        if (status === "OK") {
          const distance_ = response.rows[0].elements[0].distance.text;

          // const distance__ = convertArabicNumbersToEnglish(distance_);

          setDistance(distance_); // تخزين المسافة
          // حفظ اdistance__لبيانات في localStorage
          localStorage.setItem(
            "distance",
            JSON.stringify({ distance: distance_ })
          );
        } else {
          alert("حدث خطأ أثناء حساب المسافة.");
        }
      }
    );
  };
  //----------------------------------------
  const convertArabicNumbersToEnglish = (input) => {
    if (!input) return "";

    // استبدال الأرقام
    const arabicToEnglishMap = {
      "٠": "0",
      "١": "1",
      "٢": "2",
      "٣": "3",
      "٤": "4",
      "٥": "5",
      "٦": "6",
      "٧": "7",
      "٨": "8",
      "٩": "9",
    };

    // تحويل الأرقام والفواصل
    return input
      .replace(/[٠-٩]/g, (digit) => arabicToEnglishMap[digit]) // استبدال الأرقام
      .replace(/،/g, ","); // استبدال الفاصلة
  };

  // تحميل الخريطة وتغيير حالة isLoaded عند الانتهاء
  const handleLoad = () => {
    setIsLoaded(true); // الخريطة أصبحت جاهزة
  };

  const SaveLocation = () => {
    if (deliveryLocation) {
      localStorage.setItem(
        "deliveryLocation",
        JSON.stringify({ location: deliveryLocation, name: deliveryName })
      );
      if (Saveplase) {
        return SaveAdress();
      }

      navigate("/../Customer/Shopping/AnyShing");
    } else {
      alert("يرجى تحديد نقطة الاستلام أولاً.");
    }
  };

  //-------------------------
  async function SaveAdress() {
    try {
      const post = {
        Name: Username,
        ID: UserID,
        Action: "AddAdress",
        AdressName: deliveryName,
        AdressLat: deliveryLocation.lat,
        AdressLng: deliveryLocation.lng,
        AdressTitle: AdressTitle
      };

      const response = await fetch(API.CustomerAccount, {
        method: "POST",
        body: JSON.stringify(post),
      });
      const data = await response.json();
      if (data.errors != "") {
        return alert(data.errors);
 
      }
      navigate("/../Customer/Shopping/AnyShing");
    } catch (error) {
      return error;
    }
  }
  //-----------------------------------------
  const params = useParams();
  const imgstyle = {
    height: "100%",
  };
  // -----------------------------

  const handleChange = (e) => {
    const name = e.target.name;
    const checked = e.target.checked;
    console.log(checked);
    setSaveplase(checked);
    //setInputs((values) => ({ ...values, [name]: checked }));
  };
  return (
    <>
      <div
        className="p-1 row  text-center m-auto bg-white"
        style={{ maxWidth: "500px" }}
      >
        <div className="col-12 py-2 text-center bg-light mb-1">
          <span className="fs-6 fw-bold"> موقع تسليم الشحنة </span>
          <Link to="../Customer/Shopping/AnyShing" className="float-start">
            <i className="fa-solid fa-xmark  fs-4 "></i>
          </Link>
        </div>
        <div className="col-12 p-1">
          <input
            type="text"
            id="pickup-search"
            placeholder="ابحث فى الخريطة"
            ref={searchInputRef}
            style={{ width: "100%", padding: "10px" }}
            className="searchText"
          />
        </div>
        <div className="col-12 div-mapTo0 bg-light0 mb-2 text-end p-0 m-0" style={{ height: "45vh" }}>

          <LoadScript
            googleMapsApiKey={MAPS_API_KEY_}
            libraries={libraries}
            onLoad={handleLoad} // تعيين isLoaded على true بعد تحميل المكتبة
          >
            {isLoaded ? (
              <GoogleMap
                mapContainerStyle={mapContainerStyle}
                center={deliveryLocation}
                zoom={14}
                onClick={handleMapClick} // عند النقر على الخريطة
                onLoad={(mapInstance) => setMap(mapInstance)} // عندما يتم تحميل الخريطة
              >
                {pickupLocation && (
                  <Marker position={pickupLocation} label="استلام" />
                )}
                {deliveryLocation && (
                  <Marker position={deliveryLocation} label="تسليم" />
                )}
              </GoogleMap>
            ) : (
              <div>الخريطة في مرحلة التحميل... يرجى الانتظار</div> // عرض رسالة مخصصة عند تحميل الخريطة
            )}
          </LoadScript>
        </div>
        <div className="col-12 px-2 bg-greenLight text-end p-3" style={{ borderRadius: "10px" }}>
          <i className="fa-solid fa-location-dot text-green  mx-2"></i>
          <span>{deliveryName || "لم يتم تحديدها"}</span>
          {/* <br />
          <span>{distance}</span> */}
        </div>
        <div className="col-12 my-4 p-1 text-end">
          <h6>تفاصيل اضافية</h6>
          <input
            type="text"
            name="AdressTitle"
            className="form-control"
            placeholder="رقم المنزل / العمارة / الشقة (اختيارى)"
            value={AdressTitle}
            onChange={(e)=>{setAdressTitle(e.target.value)}}
          />
          <div dir="ltr" className="mt-3">
            <label htmlFor="Saveplase" className="text-secondary mt-0">
              {"حفظ المكان لاستخدامة لاحقا  "}
            </label>

            <input
              id="Saveplase"
              type="checkbox"
              name="Saveplase"
              className="mx-2"
              checked={Saveplase}
              // onChange={(e) => {
              //setinputs({ ...inputs, active: event.target.checked });
              // }}

              onChange={handleChange}
            />
          </div>

          {/* <button
            className="btn btn-green w-100 fw-bold p-2 mt-3"
            onClick={() => SaveLocation()}
          >
            {" موقع تسليم الشحنة"}
          </button> */}
        </div>
      </div>
      <div className="row buttom-div p-1 bg-white">
        <div className="col-12 text-center pt-2 mb-2">
          <button
            className="btn btn-green w-75 p-2 fw-bold radius"
            style={{ borderRadius: "50px" }}
            onClick={() => SaveLocation()}
          >
            {" موقع تسليم الشحنة"}
          </button>
        </div>
      </div>

    </>
  );
}
